export const appConfig = {
  // if running within MFE, use the path provided by the MFE or default to /extract
  // if running standalone, don't set a basePath
  basePath: (window as any).__skeletonInput ? (window as any).__skeletonInput.path || "/extract" : undefined,
};
